export const changeTheme = () => ({ type: "CHANGE_UI_THEME" });

export const setTheme = (theme) => ({
  type: "SET_UI_THEME",
  payload: theme,
});

export const setBusy = (busy) => ({
  type: "SET_BUSY",
  payload: busy,
});
